import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  ViewChild
} from '@angular/core';

import { DropdownSingleComponent } from './components/dropdown-single.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { app_ShellService } from './app.shell.service';
import { app_OperationService } from './app.operation.service';
import { app_DatasourceService } from './app.datasource.index';
import { app_FlowService } from './app.flow.index';
import { app_FrontendFlowService } from './app.frontend.flow.service';
import { app_ReportService } from './app.report.index';
import { app_LocalizationService } from './app.localization.service';
import { app_home_ComponentContextService } from './app.home.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { $frontendTypes} from './app.frontend.types'
import { $frontendTypes as $types} from './app.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  imports: [
    SharedModule,
  ],
  selector: 'app-home',
  templateUrl: './app.home.component.html'
})
export class app_homeComponent implements OnInit {

  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  toolbar = {
  };


  fieldsets = {
  };

  @ViewChild('dd_config') dd_config: DropdownSingleComponent;
  @ViewChild('dd_method') dd_method: DropdownSingleComponent;

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: app_ShellService,
private $datasources: app_DatasourceService,
private $flows: app_FlowService,
private $frontendFlows: app_FrontendFlowService,
private $reports: app_ReportService,
private $localization: app_LocalizationService,
private $operations: app_OperationService,
private $context: app_home_ComponentContextService,
) { 

  }

  ngOnInit(): void {
    this.$init();
  
  }

  initialized = false;

  async $init() {
    this.title = 'Home';
    this.initialized = true;
  }

  close() {
    this.$finish.emit();
  }

  typeValue = null;
  typeList = [
    {
      key: 6,
      name: 'Datasource'
    },
    {
      key: 9,
      name: 'Function'
    }
  ];

  async typeDisplayWithFn(value: any): Promise<string> {
    return this.typeList.find(item => item.key === value)?.name;
  }

  async typeOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    if (this.$utils.isDefinedTrimmed(filterText)) {
      return { list: this.typeList.filter(item => item.name.startsWith(filterText)), totalCount: this.typeList.length };
    } else {
      return { list: this.typeList, totalCount: this.typeList.length };
    }
  }

  typeValueChange(value) {
    this.typeValue = value;
    this.configValueChange(null);
    this.dd_config.clearListData();
  }


  configValue = null;
  config = null;
  configList = [
    {
      key: 'purchase_orders/cancel',
      name: 'purchase_orders/cancel' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'cancel_purchase_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_ids',
            type: 'number',
            isCollection: true
          },
        ]
    },
    {
      key: 'sales_order_lines/cancel',
      name: 'sales_order_lines/cancel' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'cancel_sales_order_lines_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_id',
            type: 'number',
            isCollection: false
          },
          {
            required: true,
            id: 'order_line_numbers',
            type: 'number',
            isCollection: true
          },
          {
            required: true,
            id: 'reason_code_id',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'reason_notes',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'sales_orders/cancel',
      name: 'sales_orders/cancel' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'cancel_sales_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_ids',
            type: 'number',
            isCollection: true
          },
        ]
    },
    {
      key: 'accounts/create',
      name: 'accounts/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_accounts_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'accounts',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'asn_orders/create',
      name: 'asn_orders/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_asn_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'orders',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'carriers/create',
      name: 'carriers/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_carriers_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'carriers',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'contacts/create',
      name: 'contacts/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_contacts_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'contacts',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'lots/create',
      name: 'lots/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_lots_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'lots',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'materials/create',
      name: 'materials/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_materials_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'materials',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'order_addresses/create',
      name: 'order_addresses/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_order_addresses_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_addresses',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'purchase_order_lines/create',
      name: 'purchase_order_lines/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_purchase_order_lines_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_lines',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'purchase_orders/create',
      name: 'purchase_orders/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_purchase_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'orders',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'sales_order_lines/create',
      name: 'sales_order_lines/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_sales_order_lines_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_lines',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'sales_orders/create',
      name: 'sales_orders/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_sales_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'orders',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'vendor_lots/create',
      name: 'vendor_lots/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'create_vendor_lots_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'vendor_lots',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'orders/create',
      name: 'orders/create' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'footprint_generic_json_order_import_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'orders',
            type: 'object',
            isCollection: true
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'ingress_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'source_lookup_code',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'source_platform',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'order_type',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'order_action',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'account_action',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'submitAsync',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'integration_name',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'environment',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'sender',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'receiver',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'debug',
            type: 'boolean',
            isCollection: false
          },
        ]
    },
    {
      key: 'accounts/get',
      name: 'accounts/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_accounts_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'asn_orders/get',
      name: 'asn_orders/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_asn_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'paging',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'exclude',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'carriers/get',
      name: 'carriers/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_carriers_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'contacts/get',
      name: 'contacts/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_contacts_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'inventory/adjustments/get',
      name: 'inventory/adjustments/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_inventory_adjustments_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'as_export',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'paging',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'inventory/get',
      name: 'inventory/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_inventory_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'paging',
            type: 'object',
            isCollection: false
          },
          {
            required: true,
            id: 'warehouse',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'output_weight_uom',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'lots/get',
      name: 'lots/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_lots_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'paging',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'exclude',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'materials/get',
      name: 'materials/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_materials_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'order_addresses/get',
      name: 'order_addresses/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_order_addresses_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_ids',
            type: 'number',
            isCollection: true
          },
        ]
    },
    {
      key: 'sales_orders/confirmation/get',
      name: 'sales_orders/confirmation/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_outbound_orders_confirmation',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'outbound_order_ids',
            type: 'number',
            isCollection: true
          },
        ]
    },
    {
      key: 'purchase_orders/get',
      name: 'purchase_orders/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_purchase_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'paging',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'exclude',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'as_export',
            type: 'boolean',
            isCollection: false
          },
        ]
    },
    {
      key: 'purchase_orders/confirmation/get',
      name: 'purchase_orders/confirmation/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_return_notifications',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_ids',
            type: 'number',
            isCollection: true
          },
        ]
    },
    {
      key: 'sales_orders/get',
      name: 'sales_orders/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_sales_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'paging',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'exclude',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'as_export',
            type: 'boolean',
            isCollection: false
          },
        ]
    },
    {
      key: 'serial_numbers/get',
      name: 'serial_numbers/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_serial_numbers_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'owner',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'project',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'material',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'vendor_lot',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'lot',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'license_plate',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'lookup',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'is_archived',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouse',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'top',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'skip',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'vendor_lots/get',
      name: 'vendor_lots/get' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'get_vendor_lots_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'paging',
            type: 'object',
            isCollection: false
          },
          {
            required: false,
            id: 'filters',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'serial_numbers/move',
      name: 'serial_numbers/move' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'move_serial_numbers_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'serial_numbers',
            type: 'object',
            isCollection: true
          },
          {
            required: true,
            id: 'target_license_plate',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'accounts/update',
      name: 'accounts/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_accounts_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'accounts',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'asn_orders/update',
      name: 'asn_orders/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_asn_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'asn_orders',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'carriers/update',
      name: 'carriers/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_carriers_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'carriers',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'contacts/update',
      name: 'contacts/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_contacts_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'contacts',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'dock_appointments/update',
      name: 'dock_appointments/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_dock_appointments_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'dock_appointments',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'lots/update',
      name: 'lots/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_lots_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'lots',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'materials/update',
      name: 'materials/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_materials_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'materials',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'order_addresses/update',
      name: 'order_addresses/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_order_addresses_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_addresses',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'pallet_transactions/update',
      name: 'pallet_transactions/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_pallet_transactions_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'pallet_transactions',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'purchase_order_lines/update',
      name: 'purchase_order_lines/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_purchase_order_lines_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_lines',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'purchase_orders/update',
      name: 'purchase_orders/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_purchase_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'purchase_orders',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'sales_order_lines/update',
      name: 'sales_order_lines/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_sales_order_lines_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'order_lines',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'sales_orders/update',
      name: 'sales_orders/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_sales_orders_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'sales_orders',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'serial_numbers/status/update',
      name: 'serial_numbers/status/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_serial_number_statuses_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'serial_numbers',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'serial_numbers/update',
      name: 'serial_numbers/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_serial_numbers',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'serial_numbers',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'shipments/update',
      name: 'shipments/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_shipments',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'shipments',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'vendor_lots/update',
      name: 'vendor_lots/update' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'update_vendor_lots_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'vendor_lots',
            type: 'object',
            isCollection: true
          },
        ]
    },
  ];

  async configDisplayWithFn(value: any): Promise<string> {
    return this.configList.find(item => item.key === value)?.name;
  }

  async configOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.configList.filter(item => item.type === this.typeValue);
    const totalCount = list.length;
    if (this.$utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  configValueChange(value) {
    this.configValue = value;
    this.config = this.configList.find(item => item.key === value);
    this.methodValueChange(null);
    this.dd_method.clearListData();
  }

  get hasMethods():boolean {
    return this.config && this.config?.methods;
  }
  
  method = null;
  methodValue = null;

  async methodDisplayWithFn(value: any): Promise<string> {
    return value;
  }

  async methodOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.config.methods;
    const totalCount = list.length;
    if (this.$utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  methodValueChange(value) {
    this.methodValue = value;
    this.result = null;    
    if (this.hasMethods) {
      this.method = this.config.methods.find(item => item.key === value);
    } else {
      this.method = null;
    }
    this.onInParamChanged();
  }


  get inParams() {
    if (this.config) {
      if (this.config.methods) {
        if (this.method) {
          return this.method.inParams;
        }
      } else {
        return this.config.inParams;
      }
    }
    return null;
  }

  previewInParams = null;
  onInParamChanged() {
    this.previewInParams = {};
    if (this.inParams && this.inParams.length) {
      const inParams: { [key: string]: any } = {};
      this.inParams.forEach(ip => {
        inParams[ip.id] = this.evaluateValue(ip.value);
      });
      this.previewInParams = inParams;
    }
  }

  evaluateValue(value: string) {
    const val = this.$utils.isDefinedTrimmed(value) ? `(${value})` : value;
    const f = new Function(`{ return ${val} }`);
    return f();
  }

  get canExecute (): boolean {
    if (!this.config) {
      return false;
    }
    if (this.config.type === 6 && !this.methodValue) {
      return false;
    } 
    return true;
  }

  result: any;
  async run() {
    if (this.config.type === 6) {
      this.result = await this.$datasources[this.config.appReferenceName][this.config.referenceName][this.methodValue](this.previewInParams);
    } else if (this.config.type === 9) {
      this.result = await this.$flows[this.config.appReferenceName][this.config.referenceName](this.previewInParams);
    }
  }  
}
